import { useEffect, useState } from 'react';
import { useOidcAccessToken } from '@axa-fr/react-oidc';
import { Authorization_AccessTokenPayload, EAuthorization_Features } from '@shared/api';
import { BooleanPermissions, BooleanFeatures } from '../../interfaces';
import { mapPermissionsToBooleanObject, mapFeaturesToBooleanObject } from '../../api';

interface Returned {
    token: Authorization_AccessTokenPayload;
    permissions: BooleanPermissions | null;
    features: BooleanFeatures | null;
    roles: EAuthorization_Features[] | null;
}

export function useClaims(): Returned {
    const { accessTokenPayload } = useOidcAccessToken() as {
        accessTokenPayload: Authorization_AccessTokenPayload;
    };

    const [permissions, setPermissions] = useState<BooleanPermissions | null>(null);
    const [features, setFeatures] = useState<BooleanFeatures | null>(null);
    const [roles, setRoles] = useState<EAuthorization_Features[] | null>(null);

    useEffect(() => {
        setPermissions(mapPermissionsToBooleanObject(accessTokenPayload?.resource_access?.account?.roles || null));
        setFeatures(mapFeaturesToBooleanObject(accessTokenPayload?.realm_access?.roles || null));
        setRoles(accessTokenPayload?.realm_access?.roles || null);
    }, [accessTokenPayload]);

    return {
        permissions,
        features,
        token: accessTokenPayload,
        roles,
    };
}
